export enum MimeType {
  PDF = 'application/pdf',
  JPEG_IMAGE = 'image/jpeg',
  PNG_IMAGE = 'image/png',
  GIF_IMAGE = 'image/gif',
  TEXT_FILE = 'text/plain',
  JSON = 'application/json',
  ZIP_ARCHIVE = 'application/zip',
  CSV = 'text/csv',
  MP4_VIDEO = 'video/mp4',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformatsofficedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
